import { render, staticRenderFns } from "./FrameMobileFichaje.vue?vue&type=template&id=bd3658b0"
import script from "./FrameMobileFichaje.vue?vue&type=script&lang=js"
export * from "./FrameMobileFichaje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports